module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/04_shape-md-b71726b264b5834b2d703dc48cd84924.png";